import * as React from 'react';
import Loading from '../../../../../components/Loading';
import {FormattedNumber} from 'react-intl';
import {IPremium} from '../../../../../data/api/models';
import {format} from 'date-fns';

interface IQuoteSummaryHeaderProps {
  tripType: string,
  premium?: IPremium,
  quoteReference?: string;
  schemeId?: string;
}

const QuoteSummaryHeader: React.FC<IQuoteSummaryHeaderProps> = ({
                                                                  tripType,
                                                                  premium = null,
                                                                  schemeId,
                                                                  quoteReference = '',
                                                                }: IQuoteSummaryHeaderProps) => {

  const validUntil = premium?.validUntil ? format(new Date(premium.validUntil), 'dd/MM/yyyy') : null;

  return (
    <div className={'quote-summary-header'}>
      <div className={'sea-bg'}/>
      <div className={'page-header-content-wrapper'}>
        <div className={'page-header-container'}>
          <div className="logo-container">
            <div className="logo-link">
              <img src={require('../../../../Shell/scenes/Header/img/admiral_logo.png')} alt="Admiral"/>
            </div>
            <div className="logo-divider"/>
            <div className="logo-title">
              Travel
            </div>
          </div>
          <img className={'admiral-bg--sm'} src={require('../../../img/admiral-sm.png')}/>
          <img className={'admiral-bg--lg'} src={require('../../../img/admiral-lg.png')}/>
          <div className={'page-header-content'}>
            <div className={'title-section'}>
              <h2>Here's your <span style={{ letterSpacing: '1px' }}>f</span>inal price for</h2>
              <h2>{tripType === 'annual' ? 'Annual Multi-Trip' : 'Single-Trip'} Travel Insurance</h2>
            </div>

            {!schemeId && <div className={'price-container-empty'}/>}

            {schemeId && <div className={'price-container'}>
              <div className={'price-display-value'}>
                {!premium && (
                  <Loading/>
                )}
                {premium && (
                  <FormattedNumber
                    value={premium.gross}
                    style="currency"
                    currency={premium.currency}
                  />
                )}
              </div>
            </div>}
            {quoteReference && (
              <div className={'quote-reference'}>Quote
                Reference {quoteReference} valid&nbsp;until&nbsp;{validUntil}</div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
};

export default QuoteSummaryHeader;
